import * as types from './types';

const INITIAL_STATE = {
  importLogReport: {
    fetching: false,
    report: null,
    error: null,
  },
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.IMPORTLOG_BEGIN_FETCH_REPORT:
      return {
        ...state,
        importLogReport: {
          ...state.importLogReport,
          fetching: true,
        },
      };
    case types.IMPORTLOG_GET_REPORT: {
      const { Data } = action.payload;
      return {
        ...state,
        importLogReport: {
          ...state.importLogReport,
          report: `data:application/pdf;base64,${Data}`,
        },
      };
    }
    case types.IMPORTLOG_END_FETCH_REPORT:
      return {
        ...state,
        importLogReport: {
          ...state.importLogReport,
          fetching: false,
        },
      };
    case types.IMPORTLOG_CLEAR:
      return {
        importLogReport: {
          fetching: false,
          report: null,
          error: null,
        },
      };
    case types.IMPORTLOG_ERROR:
      return {
        ...state,
        importLogReport: {
          fetching: false,
          report: null,
          error: action.payload.response,
        },
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/importlog/state/reducer.js